import { render } from "./LightDarkSwtich.vue?vue&type=template&id=044f338c&scoped=true&ts=true"
import script from "./LightDarkSwtich.vue?vue&type=script&lang=ts"
export * from "./LightDarkSwtich.vue?vue&type=script&lang=ts"

import "./LightDarkSwtich.vue?vue&type=style&index=0&id=044f338c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044f338c"]])

export default __exports__